import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/availabilityTimeslot/importer/availabilityTimeslotImporterActions'

export default importerReducers(actions)
